import React from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import "./soldOutStamp.scss";

const SoldOutStamp = () => {
    const { t } = useGranite();
    return (
        <div className="sold-out-stamp d-flex justify-content-center align-items-center">
            <div className="sold-out-stamp__stampHolder">
                <span className="sold-out-stamp__stamp">
                    {t("ecommerce.box.soldout")}
                </span>
            </div>
        </div>
    );
};

export default SoldOutStamp;
